/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TradeStatus = {
    FILLED: 'Filled',
    CANCELLED: 'Cancelled'
} as const;
export type TradeStatus = typeof TradeStatus[keyof typeof TradeStatus];


export function instanceOfTradeStatus(value: any): boolean {
    for (const key in TradeStatus) {
        if (Object.prototype.hasOwnProperty.call(TradeStatus, key)) {
            if (TradeStatus[key as keyof typeof TradeStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TradeStatusFromJSON(json: any): TradeStatus {
    return TradeStatusFromJSONTyped(json, false);
}

export function TradeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeStatus {
    return json as TradeStatus;
}

export function TradeStatusToJSON(value?: TradeStatus | null): any {
    return value as any;
}

export function TradeStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TradeStatus {
    return value as TradeStatus;
}

